
import sessionService from '@/app-domains/user/session/session.service'
import store from '@/core/store'
import { setLabelsAndBoxesMap } from '@/core/store/Slices/ContainersMapSlice'
import { debounce } from 'lodash'
import BoxesService from '../app-domains/boxes/boxes.service'
import labelsService from '../app-domains/labels/labels.service'

class ContainersService {
  constructor () {
    this.debouncedSetLabelsAndBoxesMap = debounce(this.setLabelsAndBoxesMap, 500)
  }

  generateContainersMap () {
    const boxes = BoxesService.getUserBoxesFromStore()
    const labels = labelsService.getLabelsFromStore()
    const labelsAndBoxesMap = this.generateBoxLabelsToBoxesMap(labels, boxes)
    this.setLabelsAndBoxesMap(labelsAndBoxesMap)
  }

  getContainersMap () {
    return store.getState().containers.containersMap
  }

  setLabelsAndBoxesMap (labelsAndBoxesMap) {
    return debounce((containersMap) => {
      const areContainersSet = this.areContainersSet()

      store.dispatch(setLabelsAndBoxesMap({ labelsAndBoxesMap: containersMap }))
      if (!areContainersSet) {
        store.commit('CONTAINERS:set')
      } else {
        setTimeout(() => store.commit('CONTAINERS:UPDATED'), 200)
      }
    }, 500)(labelsAndBoxesMap)
  }

  areContainersSet () {
    return store.getState().containers.isSet
  }

  generateBoxLabelsToBoxesMap (labels, boxes) {
    if (!Object.keys(labels).length > 0) { return {} }
    const labelsToBoxesMap = {}
    const generalLabelKey = 'no-label'
  
    for (const key in labels) {
      const idKey = labels[key].composedid
      labelsToBoxesMap[idKey] = {
        boxes: [],
        ...labels[key]
      }
      labelsToBoxesMap[generalLabelKey] = { boxes: [], name: 'Unlabeled', role: 'default', type: 'no-labeled', isShown: sessionService.hasUnlabeledVisible() }
    }
      
    for (const box of Object.values(boxes)) {
      if (!box.archived) {
      // Getting labels in which the box needs to be injected
        const boxLabels = box.boxlabels
      
        if (Array.isArray(boxLabels) && boxLabels.length > 0) {
          for (const label of boxLabels) {
          // TODO: REMOVE THIS FALLBACK, since it's used when a box gets some of its labels deleted
            if (labelsToBoxesMap[label.composedid]) {
              labelsToBoxesMap[label.composedid].boxes.push(box)
            } else {
              labelsToBoxesMap[generalLabelKey].boxes.push(box)
            }
          }
        } else {
          labelsToBoxesMap[generalLabelKey].boxes.push(box)
        }
      }
    }
    
    return labelsToBoxesMap
  }
}

export default new ContainersService()
